import { useProfile } from '@phx-husky/use-profile';
import React from 'react';

import { SecuritySectionProps } from '../models';
import { filterFields } from '../utils';
import { ChangePassword } from './change-password';
import { DeleteAccount } from './delete-account';
import { Legals } from './legals';

export const SecuritySection = ({
  fields,
  editButtonDisabled,
  onAccountDelete,
  onFormCloseCallback,
}: SecuritySectionProps) => {
  const { isPasswordProviderUser } = useProfile();

  return (
    <>
      {isPasswordProviderUser() && (
        <ChangePassword
          fields={filterFields(fields, ['currentPassword', 'password'])}
          editButtonDisabled={editButtonDisabled}
          onFormCloseCallback={onFormCloseCallback}
        />
      )}
      <Legals
        fields={filterFields(fields, ['legals'])}
        onFormCloseCallback={onFormCloseCallback}
      />
      <DeleteAccount
        fields={filterFields(fields, [
          ...(isPasswordProviderUser() ? ['loginPassword'] : []),
          'deleteAccountStatement',
        ])}
        onAccountDelete={onAccountDelete}
        editButtonDisabled={editButtonDisabled}
        onFormCloseCallback={onFormCloseCallback}
      />
    </>
  );
};
